/** Eine freie Startzeit, wie `/offers/{id}/slots` sie liefert. */
export interface SlotLike {
  startsAt: string;
  endsAt: string;
}

/** Die Slots eines Tages, mit Beschriftungen in Ortszeit. */
export interface SlotDay<Slot extends SlotLike> {
  /** Ortsdatum JJJJ-MM-TT, als stabiler Schlüssel. */
  date: string;
  /** Etwa „Mo., 3. Nov.“ */
  label: string;
  slots: { slot: Slot; time: string }[];
}

/**
 * Gruppiert Slots nach Tag in der Zeitzone des Orts.
 *
 * Bewusst nicht in der des Geräts: wer aus Lissabon eine Massage in Berlin bucht,
 * meint 10 Uhr Berliner Zeit. Ein Termin, der auf dem Telefon eine Stunde früher
 * erscheint, wäre ein Fehler, den erst die Praxis bemerkt.
 */
export function groupSlotsByDay<Slot extends SlotLike>(
  slots: Slot[],
  timeZone: string,
  locale = "de-DE",
): SlotDay<Slot>[] {
  const dateKey = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
  const dayLabel = new Intl.DateTimeFormat(locale, {
    timeZone,
    weekday: "short",
    day: "numeric",
    month: "short",
  });
  const timeLabel = new Intl.DateTimeFormat(locale, {
    timeZone,
    hour: "2-digit",
    minute: "2-digit",
  });

  const days = new Map<string, SlotDay<Slot>>();
  for (const slot of slots) {
    const instant = new Date(slot.startsAt);
    const date = dateKey.format(instant);
    let day = days.get(date);
    if (!day) {
      day = { date, label: dayLabel.format(instant), slots: [] };
      days.set(date, day);
    }
    day.slots.push({ slot, time: timeLabel.format(instant) });
  }
  return [...days.values()].sort((a, b) => a.date.localeCompare(b.date));
}
